// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const UNDO = "Vr\u00e1\u0165 sp\u00e4\u0165";
